import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 17", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 17V11H12V17H17V9H20L10 0L0 9H3V17H8Z" }));
const ForwardRef = forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
